<template>
    <div :class="{'list-item': true,selectable,'selected': selected}"
         @click="clickBooking">
        <loading-component :value="loading"/>
        <h5 v-if="item.passenger && !item.passenger.approved_at && item.service.is_pooling"
            style="color: white; background-color: black;"
            @click="openConfirmPassengerDialog">
            Not Approved <span
                :style="[item.passenger.id_card_front || item.passenger.id_card_front ? {color: 'green'} : {color: 'red'}]">{{item.passenger.id_card_front || item.passenger.id_card_front ? 'With docs' : 'Without docs'}}</span>
        </h5>
        <h5 v-if="!!item.meta && !!item.meta.round_trip">
            <div style="font-weight: bold; color: orange; background-color: white; padding: 2px; display: inline-block;">
                ROUND TRIP
            </div>
        </h5>
        <h5 v-if="!!item.captain_cancellations && item.captain_cancellations.length > 0">
            <div style="font-weight: bold; color: orange; background-color: white; padding: 2px; display: inline-block;">
                (REQUEUED)
            </div>
        </h5>
        <v-alert v-if="dispatch_suggestion.count_down !== '00:00'" :value="true" type="info" icon="fa-fqwfqw"
                 style="padding: 3px">
            {{dispatch_suggestion.captain_name}} - {{dispatch_suggestion.count_down}}
        </v-alert>
        <div v-if="!!item">
            <h5 v-if="!!item.suggestions">
                <template v-if="item.suggestions.filter(suggest => suggest.status === 'ACCEPTED').length > 0">
                    Accepted a suggestions
                </template>
                <template v-else-if="item.suggestions.filter(suggest => suggest.status === 'REFUSED').length > 0">
                    Refused a suggestions
                </template>
                <template v-else-if="item.suggestions.filter(suggest => suggest.status === 'SENT').length > 0">
                    Hasn't Responded to suggestion
                </template>
            </h5>
            <h5 v-if="!!item.passenger">
                <router-link :to="{name: 'PassengerProfile',params: {id: item.passenger.id}}" target="_blank">
                    {{item.passenger.first_name + ' ' +
                    item.passenger.last_name}} ({{item.passenger.username}})
                </router-link>
                <b>
                    <template
                            v-if="item.passenger.active_loyalty_classes && item.passenger.active_loyalty_classes.length >= 1 ">
                        <template v-if="item.passenger.active_loyalty_classes[0].name  === 'P0'">
                            <img :src="P0Image" alt="P0" width="32px" style="display: inline; "/>
                        </template>
                        <template v-else-if="item.passenger.active_loyalty_classes[0].name  === 'P1'">
                            <img :src="P1Image" alt="P1" width="32px" style="display: inline; "/>
                        </template>

                        <template v-else-if="item.passenger.active_loyalty_classes[0].name  === 'P2'">
                            <img :src="P2Image" alt="P2" width="32px" style="display: inline; "/>
                        </template>

                        <template v-else-if="item.passenger.active_loyalty_classes[0].name  === 'P3'">
                            <img :src="P3Image" alt="P3" width="32px" style="display: inline; "/>
                        </template>


                        <b v-else>
                            {{item.passenger.active_loyalty_classes[0].name}}
                        </b>
                    </template>
                    <template v-else>
                        <b>NO CLASS</b>
                    </template>
                </b>
            </h5>
            <h4 style="position: relative;">
                {{ formatCompanyTime(item.datetime, 'HH:mm') }}
                <template v-if="item.is_eta">
                    (ETA +5)
                    <template v-if="item.eta_captain">
                        With {{item.eta_captain.first_name}} {{item.eta_captain.last_name}}
                    </template>
                </template>
                <span v-else-if="item.airport_office"
                      @click="showAirportRequestDetails(item.id)"
                      class="item-selected-important">
                    <v-icon>fa fa-plane</v-icon>
                </span>
                <span v-else-if="!!item.passenger && !!item.passenger.rejected_count && !hideRejectedCounter"
                      class="item-selected-rejected">
                    {{item.passenger.rejected_count}}
                </span>
            </h4>
            <h4>{{item.service.name}}
                <v-img class="booking-service-icon"
                       :src="api.GET_IMAGE(item.service.icon)"/>
                <template
                        v-if="!!item.last_service_change_suggestion && item.last_service_change_suggestion.accepted_at === null">
                    <div style="background-color: white; color: black; display: inline;">
                        ->{{item.last_service_change_suggestion.new_service.name}} ?
                        <a @click.stop="acceptLastSuggestion">
                            Pax Accepted
                        </a>
                    </div>
                </template>
            </h4>
            <h5>Creation time:
                {{ formatCompanyTime(item.created_at, 'YYYY-MM-DD HH:mm') }}</h5>
            <h5>From: {{item.pick_up_location_name}}
                <template v-if="item.pick_up_location_details">
                    <br/><span style="color: #808080">( {{item.pick_up_location_details}} )</span>
                </template>
                <template v-else-if="item.pick_up_voice_recording">
                    <br/>
                    <audio controls style="width: calc(100% - 16px); margin-left: 8px; margin-right: 8px" :src="api.MAIN_URL + item.pick_up_voice_recording"/>
                </template>
            </h5>
            <h5 v-for="stop in item.stops">
                Stop:  {{stop.location_name}}
            </h5>
            <h5>To: {{item.pull_down_location_name}}
                <template v-if="item.pull_down_location_details">
                    <br/><span style="color: #808080">( {{item.pull_down_location_details}} )</span>
                </template>
            </h5>
            <h5 v-if="!!item.voucher">
                Voucher:
                {{item.voucher.code}}
            </h5>
            <template v-if="!hideActions">
                <v-btn small flat icon color="secondary">
                    <v-icon color="secondary" @click.stop="$emit('map')">map
                    </v-icon>
                </v-btn>
                <v-btn v-if="!hideCancel" small flat icon @click.stop="$emit('reject')" color="orange">
                    <v-icon color="orange">close</v-icon>
                </v-btn>
                <v-btn v-if="!hideApprove" small flat icon @click.stop="$emit('approve')" color="orange">
                    <v-icon color="green">check</v-icon>
                </v-btn>
                <v-btn v-if="!hideApprove" small flat icon @click.stop="$emit('delete')" color="red">
                    <v-icon color="red">fa-trash</v-icon>
                </v-btn>
                <!--                <v-btn small flat icon @click.stop="$emit('dispatchSuggest')" color="blue">-->
                <!--                    <v-icon color="blue">fa-paper-plane</v-icon>-->
                <!--                </v-btn>-->
                <v-btn small flat icon @click.stop="$emit('dispatchSuggestions')" color="default">
                    <v-icon color="default">fa-history</v-icon>
                </v-btn>
                <v-tooltip bottom v-if="actualNotes.length > 0">
                    <template v-slot:activator="{ on }">
                        <v-btn small color="orange" flat icon @click.stop="notesDialog = true" v-on="on">
                            <v-icon color="orange">
                                speaker_notes
                            </v-icon>
                        </v-btn>
                    </template>
                    <span class="title">{{actualNotes[0].note}}</span>
                </v-tooltip>
                <template
                        v-if="changeService && item.passenger.can_use_vip && [1,2,7].indexOf(item.service_id) !== -1 ">
                    <v-btn v-if="item.service_id !== 7" small color="green" flat icon @click.stop="toVip">
                        ->VIP
                    </v-btn>
                    <template v-else>
                        <v-btn small color="green" flat icon @click.stop="toFullCar">
                            ->FC
                        </v-btn>
                        <v-btn small color="green" flat icon @click.stop="toPooling">
                            ->P
                        </v-btn>
                    </template>
                </template>
            </template>
            <v-dialog v-model="showUpdateDialog" v-if="showUpdateTime" lazy width="300px">
                <template slot="activator">
                    <v-btn small flat color="primary">
                        Change Time
                    </v-btn>
                </template>
                <v-card>
                    <v-form ref="form">
                        <v-card-text>
                            <v-text-field label="Date" v-model="date" type="date"/>
                            <v-text-field label="Time" v-model="time" type="time"/>
                            <v-checkbox label="Detach voucher if needed" v-model="detach_voucher"></v-checkbox>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn :loading="loading" color="primary" @click="updateTime" large>
                                update
                            </v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
        </div>
        <confirm-passenger-dialog @approved="approved" ref="confirm_dialog"
                                  :settings.sync="confirm_passenger_dialog"></confirm-passenger-dialog>
        <v-dialog v-if="actualNotes.length > 0" v-model="notesDialog" lazy>
            <v-card>
                <v-card-title primary-title class="title font-weight-bold">
                    Notes
                </v-card-title>
                <v-divider/>
                <v-card-text>
                    <v-data-table
                            :items="actualNotes"
                            class="elevation-1"
                            hide-actions
                            hide-headers
                    >
                        <template v-slot:items="props">
                            <td>{{ props.item.id }}</td>
                            <td class="text-xs-left">{{ props.item.note }}</td>
                            <td class="text-xs-left">{{ props.item.author_id }}</td>
                            <td class="text-xs-left">{{ props.item.created_at}}</td>
                            <td class="text-xs-right">
                                <v-btn color="blue" class="white--text" @click="solve(props.item.id)">
                                    Solve
                                </v-btn>
                            </td>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog" max-width="600px">
            <v-card>
                <v-card-title class="headline">Airport request details</v-card-title>
                <v-card-text>
                    <v-container text-xs-center>
                        <v-layout row>
                            <v-flex xs4>
                                <b>Agent</b>
                            </v-flex>
                            <v-flex xs8>
                                {{airport_details.agent}}
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <v-layout row>
                            <v-flex xs4>
                                <b>Airline</b>
                            </v-flex>
                            <v-flex xs8>
                                {{airport_details.air_agency_name}}
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <v-layout row>
                            <v-flex xs4>
                                <b>Pax name</b>
                            </v-flex>
                            <v-flex xs8>
                                {{airport_details.first_name}} {{airport_details.last_name}}
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <v-layout row>
                            <v-flex xs4>
                                <b>Pax phone</b>
                            </v-flex>
                            <v-flex xs8>
                                {{airport_details.phone_number}}
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <v-layout row>
                            <v-flex xs4>
                                <b>Pax whatsapp</b>
                            </v-flex>
                            <v-flex xs8>
                                {{airport_details.whatsapp_number}}
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <v-layout row>
                            <v-flex xs4>
                                <b>#Riders</b>
                            </v-flex>
                            <v-flex xs8>
                                {{airport_details.riders >= 0 ? airport_details.riders : '+4'}}
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <v-layout row>
                            <v-flex xs4>
                                <b>#Bags</b>
                            </v-flex>
                            <v-flex xs8>
                                {{airport_details.bags >= 0 ? airport_details.bags : '+4'}}
                            </v-flex>
                        </v-layout>

                        <v-divider></v-divider>
                        <v-layout row>
                            <v-flex xs4>
                                <b>PNR</b>
                            </v-flex>
                            <v-flex xs8>
                                {{airport_details.pnr}}
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <v-layout row>
                            <v-flex xs4>
                                <b>Airport code</b>
                            </v-flex>
                            <v-flex xs8>
                                {{airport_details.country}}
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <v-layout row>
                            <v-flex xs4>
                                <b>Estimated price</b>
                            </v-flex>
                            <v-flex xs8>
                                {{ airport_details.estimated_price | money }}
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <v-layout v-show="airport_details.booking_created_at===airport_details.last_update" row>
                            <v-flex xs12>
                                <v-btn color="primary" style="width: 100%"
                                       @click="markAsReceived">Ok we received
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

    import { formatCompanyTime, toCompanyMoment, companyNow } from "@/util/companyTime";
    import LoadingComponent from "@/components/LoadingComponent";
    import ConfirmPassengerDialog from "@/components/monaco/input/ConfirmPassengerDialog";
    import P0Image from "@/assets/P0.png";
    import P1Image from "@/assets/P1.png";
    import P2Image from "@/assets/P2.png";
    import P3Image from "@/assets/P3.png";
    import hasIntervalsMixin from "@/mixins/hasIntervalsMixin";
    import socketEventsMixin from "@/mixins/socketEventsMixin";

    export default {
        name: "RequestCard",
        components: {ConfirmPassengerDialog, LoadingComponent},
        mixins: [hasIntervalsMixin, socketEventsMixin],
        props: {
            item: Object,
            selected: Boolean,
            selectable: {
                type: Boolean,
                default: true
            },
            hideApprove: Boolean,
            hideActions: Boolean,
            hideRejectedCounter: Boolean,
            showUpdateTime: Boolean,
            hideCancel: Boolean,
            changeService: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            if (this.item.active_captain_suggestion) {
                this.dispatch_suggestion.captain_name = this.item.active_captain_suggestion.captain_name;
            }
        },
        data() {
            return {
                confirm_passenger_dialog: {
                    visible: false,
                    passenger_id: null
                },
                selected_passenger: {},
                time: formatCompanyTime(this.item.datetime, 'HH:mm', ''),
                date: formatCompanyTime(this.item.datetime, "YYYY-MM-DD", ''),
                detach_voucher: false,
                showUpdateDialog: false,
                loading: false,
                notesDialog: false,
                solvedNotes: [],
                dialog: false,
                airport_details: {},
                dispatch_suggestion: {
                    count_down: "00:00",
                    captain_name: ""
                }
            }
        },
        computed: {
            P0Image() {
                return P0Image;
            },
            P1Image() {
                return P1Image;
            },
            P2Image() {
                return P2Image;
            },
            P3Image() {
                return P3Image;
            },
            dateTimeRule() {
                return () => {
                    // Both are Damascus wall clock (final-version doc 2026-10-05).
                    const picked = toCompanyMoment(this.date + ' ' + this.time);
                    const original = toCompanyMoment(this.item.datetime);
                    return (picked && original && Math.abs(picked.diff(original, "minute")) <= 120) || "Must be max of 2 hour";
                }
            },
            actualNotes() {
                if (!this.item.notes) return [];
                return this.item.notes.split('|^^^|').map(
                    item => {
                        const [id, note, author_id, created_at] = item.split('^|||^');
                        return {
                            id, note, author_id, created_at
                        }
                    }
                ).filter(({id}) => !this.solvedNotes.includes(id))
            }
        },
        intervals() {
            return [
                [() => this.dispatch_suggestion.count_down = this.computeDispatchSuggestionLeft(), 1000]
            ];
        },
        events() {
            return {
                'Dashboard:booking_suggestion_available': this.resetDispatchSuggestion,
                'Dashboard:booking_suggestion_sent': this.newDispatchSuggestion
            }
        },
        methods: {
            resetDispatchSuggestion(data) {
                if (data.booking_id === this.item.id) this.item.active_captain_suggestion = {};
            },
            newDispatchSuggestion(data) {
                if (data.booking_id === this.item.id) {
                    this.$set(this.dispatch_suggestion, 'captain_name', data.captain_name);
                    this.item.active_captain_suggestion = {until: data.until};
                }
            },
            computeDispatchSuggestionLeft() {
                // Final-version doc 2026-10-05: compare instants in company
                // time (the old string compare used the PC's zone).
                const when = this.item.active_captain_suggestion
                    ? toCompanyMoment(this.item.active_captain_suggestion.until)
                    : null;
                const left = when ? when.diff(companyNow(), 'seconds') : 0;
                if (left <= 0)
                    return "00:00";
                const minutes = Math.floor(left / 60);
                const seconds = left % 60;
                return `${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
            },
            async acceptLastSuggestion() {
                if (!confirm('Are you sure you want to update the service?'))
                    return;

                this.loading = true;

                try {
                    const {data: {message}} = await this.axios.put(this.api.ACTIONS.BOOKINGS + '/' + this.item.id, {
                        service_id: this.item.last_service_change_suggestion.new_service.id
                    });
                    window.getApp.$emit("SHOW_TOAST", message);
                } catch (e) {
                    window.getApp.$emit("SHOW_TOAST", e.response.data.message, 'red');
                } finally {
                    this.loading = false;
                }

            },
            async suggestServiceChangeTo(service_id) {
                if (!!this.item.last_service_change_suggestion && service_id === this.item.last_service_change_suggestion.new_service_id) {
                    window.getApp.$emit("SHOW_TOAST", "this suggestions was already sent!", 'red');
                    return;
                }

                if (!confirm('Are you sure you want to update the service?'))
                    return;

                this.loading = true;
                try {
                    const {data: {message}} = await this.axios.post(this.api.ACTIONS.SUGGEST_SERVICE_CHANGE(this.item.id), {service_id});
                    window.getApp.$emit("SHOW_TOAST", message, 'green');
                } catch (e) {
                    window.getApp.$emit("SHOW_TOAST", e.response.data.message, 'red');
                } finally {
                    this.loading = false;
                }
            },
            toVip() {
                this.suggestServiceChangeTo(7);
            },
            toFullCar() {
                this.suggestServiceChangeTo(2);
            },
            toPooling() {
                this.suggestServiceChangeTo(1);
            },
            markAsReceived() {
                this.axios.put(`booking/${this.airport_details.booking_id}/touch`);
                this.dialog = false;
            },
            showAirportRequestDetails(id) {
                this.loading = true;
                this.axios.get(`booking/${id}/airport_details`)
                    .then(res => {
                        this.airport_details = res.data.data;
                        this.dialog = true;
                    })
                    .catch(() => {
                        window.getApp.$emit("SHOW_TOAST", 'no extra details', "red");
                    })
                    .finally(() => this.loading = false);
            },
            openConfirmPassengerDialog() {
                this.confirm_passenger_dialog.visible = true;
                this.confirm_passenger_dialog.passenger_id = this.item.passenger_id;
            },
            approved() {
                this.item.passenger.active = true;
                this.confirm_passenger_dialog = {
                    visible: false,
                    passenger_id: null
                };
            },
            clickBooking() {
                this.$emit(!!this.selected ? "unselect" : "select", this.item);
            },
            updateTime() {
                if (this.$refs.form.validate()) {
                    this.loading = true;
                    this.axios.put(this.api.ACTIONS.BOOKINGS + '/' + this.item.id, {
                        datetime: this.date + ' ' + this.time,
                        detach_voucher: this.detach_voucher
                    }).then(() => {
                        this.$emit("updateTime", this.time);
                        this.showUpdateDialog = false;
                    }).catch(error => {
                        if (error.response.status == 422)
                            window.getApp.$emit("SHOW_TOAST", error.response.data.errors.datetime[0], "red");
                        else {
                            window.getApp.$emit("SHOW_TOAST", "ERROR HAPPENED (CHECK CONSOLE LOG)", 'red');
                            console.log(error);
                        }
                    }).finally(
                        () => {
                            this.loading = false;
                            this.detach_voucher = false;
                        }
                    );

                }
            },
            solve(id) {
                this.loading = true;
                this.axios.put(this.api.ACTIONS.NOTES + '/' + id)
                    .then(
                        () => {
                            this.solvedNotes = [...this.solvedNotes, id];
                            window.getApp.$emit("SHOW_TOAST", "SOLVED", "green");
                        }
                    )
                    .catch(
                        ({response}) => {
                            window.getApp.$emit("SHOW_TOAST", "ERRRO HAPPENED CHECK ERROR LOG", "red");
                            console.log(response);
                        }
                    )
                    .finally(
                        () => {
                            this.loading = false;
                        }
                    )
            }
        }
    }
</script>

<style scoped>

    .list-item {
        margin-bottom: 8px;
        margin-top: 8px;
        border: 1px solid white;
        transition: border 300ms linear, background-color 1s;
    }

    .booking-service-icon {
        height: 20px;
        width: 20px;
        display: inline-block;
    }

    .list-item.selectable:hover {
        border: 1px solid gray;
        cursor: pointer;
    }

    .list-item.selected {
        border: 5px dashed black !important;
    }
</style>
